import React from 'react';

import { Box, Text, useMantineTheme } from '@mantine/core';

const NoExpectationsFound = (): JSX.Element => {
  const theme = useMantineTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.colors.gray[0],
        borderRadius: theme.radius.sm,
        textAlign: 'center',
        minHeight: 100,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Text size='md' color='black' weight={500}>
        No packages added yet to the report
      </Text>
    </Box>
  );
};

export default NoExpectationsFound;
